/* Cloud9 homepage: capsule animation (scroll-scrubbed: the pinned video on desktop, 48 frames on a canvas on phones), buy bar, click-to-play videos. */
(() => {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const small = () => matchMedia("(max-width: 900px)").matches;

  /* ---- capsule animation ---- */
  // the two capsule stills (closed, labelled) wait for the hero photo too, or load at once when the capsule is close (speed, 2026-10-19)
  const stills = [...document.querySelectorAll(".c9h img[data-c9src]")];
  const showStills = () => stills.forEach((im) => { if (im.dataset.c9src) { if (im.dataset.c9srcset) { im.srcset = im.dataset.c9srcset; im.removeAttribute("data-c9srcset"); } im.src = im.dataset.c9src; im.removeAttribute("data-c9src"); } });
  if (stills.length) {
    (window.c9AfterHero || ((f) => f()))(showStills);
    new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { o.disconnect(); showStills(); } }, { rootMargin: "300px 0px" }).observe(stills[0]);
  }
  const scrub = document.querySelector(".c9h [data-scrub]");
  if (scrub) {
    const frame = scrub.querySelector(".h-frame");
    const vid = scrub.querySelector(".h-cap-vid");
    const callouts = [...scrub.querySelectorAll(".h-callout")];
    const pins = [...scrub.querySelectorAll(".h-pin")];
    const setStatic = () => frame.classList.add("static");
    if (reduce || !vid || !vid.canPlayType("video/mp4")) {
      setStatic();
    } else if (small() && (() => { try { return JSON.parse(frame.querySelector(".h-media").dataset.seq || "[]").length > 0; } catch (e) { return false; } })()) {
      // phones (Mike, 2026-10-17: "the animation on the home isn't the scroll animation on mobile"): the same 48 Daily Restore frames as
      // the product page, drawn on a canvas (video seeking stutters on iOS). No pinning: closed as the capsule rises from the bottom of the
      // screen, open by the middle, reversing on the way back up; the numbered pins show once it's open.
      const media = frame.querySelector(".h-media"), urls = JSON.parse(media.dataset.seq);
      const cv = document.createElement("canvas"); cv.className = "h-cap-canvas"; cv.setAttribute("aria-hidden", "true");
      media.insertBefore(cv, media.querySelector(".h-pin"));
      const ctx = cv.getContext("2d"), frames = new Array(urls.length);
      let loaded = 0, started = false, last = -1, raf = 0;
      const size = () => { const r = media.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2); const w = Math.round(r.width * d), h = Math.round(r.height * d); if (w === cv.width && h === cv.height) return; cv.width = w; cv.height = h; last = -1; draw(); };  /* iOS fires resize whenever the address bar moves: only rebuild on a real size change */
      const progress = () => { const r = media.getBoundingClientRect(), vh = innerHeight, c = r.top + r.height / 2; return Math.pow(Math.max(0, Math.min(1, (vh - c) / (vh * 0.5))), 1.3); };
      const nearest = (i) => { for (let k = 0; k < frames.length; k++) { if (frames[i - k] && frames[i - k].naturalWidth) return frames[i - k]; if (frames[i + k] && frames[i + k].naturalWidth) return frames[i + k]; } return null; };
      function draw() {
        raf = 0; if (!loaded) return;
        const p = progress(), i = Math.round(p * (urls.length - 1));
        frame.classList.toggle("static", p >= 0.97);
        if (i === last) return;
        const img = nearest(i); if (!img) return;
        last = i; ctx.clearRect(0, 0, cv.width, cv.height); ctx.drawImage(img, 0, 0, cv.width, cv.height);
      }
      const request = () => { if (!raf) raf = requestAnimationFrame(draw); };
      const loadFrames = () => {
        if (started) return; started = true;
        [0, urls.length - 1].concat(urls.map((_, k) => k).slice(1, -1)).forEach((k) => {
          const im = new Image(); im.decoding = "async"; im.src = urls[k];
          im.onload = () => { loaded++; if (loaded === 1) size(); request(); };
          im.onerror = () => { if (k === 0) { cv.remove(); setStatic(); } };
          frames[k] = im;
        });
      };
      // speed (Mike, 2026-10-19: "capsule animation frames load after the main photo / when scrolled near"): the 48 frames (about 800 KB)
      // used to start while the hero photo was still coming in on slow phones. Near the capsule they now wait for the hero (c9AfterHero,
      // snippets/c9-app-hold: photo painted, or the first scroll or tap); once the capsule is about to be on screen they load at once.
      const afterHero = window.c9AfterHero || ((f) => f());
      new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { o.disconnect(); afterHero(loadFrames); } }, { rootMargin: "900px 0px" }).observe(media);
      new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { o.disconnect(); loadFrames(); } }, { rootMargin: "200px 0px" }).observe(media);
      addEventListener("scroll", request, { passive: true }); addEventListener("resize", size);
    } else if (small()) {
      // phones without frames: the closed capsule waits (first video frame), the opening plays once when the capsule itself is
      // well on screen, then rests on the labelled frame (last video frame). No jump back, no scroll-jacking.
      const media = frame.querySelector(".h-media");
      let done = false;
      const load = () => { if (!vid.getAttribute("src")) { vid.muted = true; vid.defaultMuted = true; vid.playsInline = true; vid.src = vid.dataset.srcM; vid.preload = "auto"; vid.load(); } };  // iOS Safari needs muted + inline set as properties to autoplay
      const finish = () => { if (done) return; done = true; vid.pause(); setStatic(); };
      vid.addEventListener("ended", finish, { once: true });
      vid.addEventListener("error", finish, { once: true });
      const pre = new IntersectionObserver((es) => { if (es[0].isIntersecting) { pre.disconnect(); load(); } }, { rootMargin: "600px 0px" });
      pre.observe(media);
      const io = new IntersectionObserver((es) => {
        if (!es[0].isIntersecting) return;
        io.disconnect(); load();
        let started = false;
        const go = () => {
          if (started || done) return; started = true;
          frame.classList.add("vid-ready");
          vid.playbackRate = 2;  // about five seconds
          const pr = vid.play(); if (pr) pr.catch(finish);  // e.g. iPhone Low Power Mode blocks autoplay
        };
        if (vid.readyState >= 3) go(); else vid.addEventListener("canplay", go, { once: true });
        setTimeout(() => { if (!started || vid.paused) finish(); }, 4000);  // never sit on a frozen frame
      }, { threshold: 0.6 });
      io.observe(media);
    } else {
      // desktop: scroll position drives the video; each group in the legend lights up as it leaves the capsule
      let dur = 0, raf = 0;
      const load = new IntersectionObserver((es) => {
        if (!es[0].isIntersecting) return;
        load.disconnect();
        vid.src = vid.dataset.src; vid.preload = "auto"; vid.load();
      }, { rootMargin: "800px 0px" });
      load.observe(scrub);
      vid.addEventListener("loadedmetadata", () => { dur = vid.duration || 0; });
      vid.addEventListener("loadeddata", () => { frame.classList.add("vid-ready"); update(); });
      vid.addEventListener("error", setStatic);
      const update = () => {
        const r = scrub.getBoundingClientRect();
        const lead = innerHeight * 0.35;  // start while the stage is still arriving, so the opening feels quick
        const span = r.height - innerHeight + lead;
        const p = span > 0 ? Math.max(0, Math.min(1, (lead - r.top) / span)) : 0;
        const vp = Math.max(0, Math.min(1, p / 0.7)); // the opening finishes at 70% of the pinned scroll
        if (dur && frame.classList.contains("vid-ready")) {
          const t = vp * (dur - 0.05);
          if (Math.abs(vid.currentTime - t) > 0.02) { try { vid.currentTime = t; } catch (e) {} }
        }
        callouts.forEach((c, i) => { const on = p >= parseFloat(c.dataset.at); c.classList.toggle("on", on); if (pins[i]) pins[i].classList.toggle("on", on); });
      };
      addEventListener("scroll", () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; update(); }); }, { passive: true });
      addEventListener("resize", update);
      update();
    }
  }

  /* ---- floating buy bar: slides in tied to scroll after the hero, out before the final call to action ---- */
  const bar = document.querySelector(".c9h .h-bar");
  const hero = document.querySelector(".c9h .h-hero");
  const finalCta = document.querySelector(".c9h .h-final");
  if (bar && hero) {
    const upd = () => {
      let p = Math.max(0, Math.min(1, (140 - hero.getBoundingClientRect().bottom) / 220));
      if (finalCta) p = Math.min(p, Math.max(0, Math.min(1, (finalCta.getBoundingClientRect().top - innerHeight * 0.6) / 220)));
      const sc = document.querySelector(".c9h [data-scrub]");
      if (sc && !small()) {  // keep the formula moment clean: the bar steps aside while the capsule stage is pinned
        const r = sc.getBoundingClientRect();
        const inside = Math.min(1, Math.max(0, (innerHeight - r.top) / 300)) * Math.min(1, Math.max(0, (r.bottom - innerHeight * 0.4) / 300));
        p = Math.min(p, 1 - inside);
      }
      bar.style.setProperty("--p", p.toFixed(3));
      bar.classList.toggle("on", p > 0.5);
    };
    let r2 = 0;
    addEventListener("scroll", () => { if (!r2) r2 = requestAnimationFrame(() => { r2 = 0; upd(); }); }, { passive: true });
    addEventListener("resize", upd);
    upd();
  }

  /* ---- click-to-play customer and doctor videos ---- */
  document.querySelectorAll(".c9h .h-vid[data-src]").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.classList.contains("playing")) return;
      const v = document.createElement("video");
      v.src = btn.dataset.src; v.controls = true; v.playsInline = true; v.autoplay = true;
      btn.querySelector("img")?.replaceWith(v);
      btn.classList.add("playing");
      v.play().catch(() => {});
    });
  });
})();
